import { render, staticRenderFns } from "./SchemeList.vue?vue&type=template&id=58b1f4da&scoped=true&"
import script from "./SchemeList.vue?vue&type=script&lang=js&"
export * from "./SchemeList.vue?vue&type=script&lang=js&"
import style0 from "./SchemeList.vue?vue&type=style&index=0&id=58b1f4da&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58b1f4da",
  null
  
)

export default component.exports